import { Injectable } from '@angular/core';
import { IFilter } from '@shared/interfaces/filter.interface';
import { ITemplate } from '@shared/interfaces/template.interface';
import { Filter } from '@shared/models/filter.model';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';
import { TemplatesService } from '@shared/services/templates.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationTemplatesService extends PaginationService<ITemplate> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  private static readonly DEFAULT_OWNERSHIP_FILTER: IFilter = {
    label: 'FILTERS.MYSELF',
    key: 'owner',
    value: 'my'
  };

  private static readonly DEFAULT_SEARCH_FILTER: IFilter = {
    key: 'search',
    value: null
  };

  private _filtersScope: any;

  constructor(_paginable: TemplatesService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationTemplatesService.DEFAULT_IS_DELETED_FILTER,
      PaginationTemplatesService.DEFAULT_OWNERSHIP_FILTER,
      PaginationTemplatesService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationTemplatesService.DEFAULT_IS_DELETED_FILTER,
      PaginationTemplatesService.DEFAULT_OWNERSHIP_FILTER,
      PaginationTemplatesService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
